module.exports = __webpack_public_path__ + "img/Phone_07.818e9950.jpg";